import { render, staticRenderFns } from "./IconGk.vue?vue&type=template&id=587969d8"
import script from "./IconGk.vue?vue&type=script&lang=js"
export * from "./IconGk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports